export function noop() {
  // do nothing
}

export function safe<T>(cb: () => T): T | undefined {
  try {
    return cb();
  } catch (ex) {
    console.warn(ex);
  }
}

export function isDefined<T>(value: T | undefined): value is T {
  return value !== undefined || value !== null;
}
